// Interface
export interface BetRecord {
    gameId: string,
    gameName: string,
    betAmount: number,
    winAmount: number,
    income: number,
    orderNo: string,
    createTime: string
}

export interface GameLogData {
    active : number
    total : number
    pageSize : number
    pageNum : number
    tabList : any[]
    betList : BetRecord[]
    betTotal : number
    winLossAmount : number
}

// Constant
export const PAGE_SIZE = 20

export const TAB_LIST =[{ name: 'common.hours',timeName:3, time: 3 },
{ name: 'common.hours',timeName:12, time: 12 },
{ name: 'common.hours',timeName:24, time: 24 },
{ name: 'common.hours',timeName:48, time: 48 },
{ name: 'common.days',timeName:7, time: 24 * 7 },]